





import { asyncOnce, once } from "@timesheets/webapp-support";
import Vue, { PropOptions } from "vue";

export default Vue.extend({
  name: "OnceButton",

  props: {
    disabled: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,

    id: {
      type: String,
      required: true,
    } as PropOptions<string>,

    onClick: {
      type: [Function, Promise],
      required: true,
    } as PropOptions<(event: Event) => void>,

    title: {
      type: String,
      default: undefined,
    } as PropOptions<string | undefined>,
  },

  computed: {
    onceClick(): (...args: any[]) => Promise<void | undefined> | void | undefined {
      if (typeof (this.onClick as { then?: Function }).then === "function") {
        return asyncOnce(this, this.onClick, 1000);
      } else {
        return once(this, this.onClick, 1000);
      }
    },
  },
});
